import {Component, OnInit} from '@angular/core';
import {routerTransition} from '@app/router.animations';
import {UserAccessService} from '@app/shared/services/user-access.service';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';

@Component({
  selector: 'app-user-access',
  templateUrl: './user-access.component.html',
  styleUrls: ['./user-access.component.scss'],
  animations: [routerTransition()],
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent
  ]
})
export class UserAccessComponent implements OnInit {

  public user_groups: any = [];
  public user_rights: any = {};
  public user_access_list: any = [];
  public user_access_types: any = [];
  sel_user_group = "";

  constructor(public userAccessService: UserAccessService) {
  }

  ngOnInit() {
    this.getOptions();
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
  }

  changeAccessRights(module_id: any, new_value: any, index: any, userrights: any) {
    let replace = 0;
    if (new_value == true) {
      replace = 1;
    }
    const value = userrights.substring(0, index) + replace + userrights.substring(index + 1);
    const sendJson = {
      user_group: this.sel_user_group,
      module_id: module_id,
      value: value
    };

    this.userAccessService.changeAccessRights(sendJson).subscribe((result: any) => {
      if (result.status == "Success") {
        this.getGroupAccess();
      } else {
        this.getGroupAccess();
      }
    });

  }

  changeGroupAccessRights(module_group_id: any, new_value: any, index: any, userrights: any) {
    let replace = 0;
    if (new_value == true) {
      replace = 1;
    }
    const value = userrights.substring(0, index) + replace + userrights.substring(index + 1);
    const sendJson = {
      user_group: this.sel_user_group,
      module_group_id: module_group_id,
      value: value
    };

    this.userAccessService.changeAccessRights(sendJson).subscribe((result: any) => {
      if (result.status == "Success") {
        this.getGroupAccess();
      } else {
        this.getGroupAccess();
      }
    });

  }

  changeGroup(group_id: any, value: any) {
    const sendJson = {
      user_group: this.sel_user_group,
      group_id: group_id,
      value: value
    };
    this.userAccessService.changeAccessGroup(sendJson).subscribe((result: any) => {
      if (result.status == "Success") {
        this.getGroupAccess();
      } else {
        this.getGroupAccess();
      }
    });
  }

  createArray(str: any) {

    let items: any;
    items = str.split('');

    return items;
  }

  getGroupAccess() {
    const sendJson = {
      user_group: this.sel_user_group
    };
    this.userAccessService.getAccessrights(sendJson).subscribe((result: any) => {
      if (result.status == "Success") {
        this.user_access_list = result.data;
      } else {
        this.user_access_list = [];
      }
    });
  }

  getOptions() {
    this.userAccessService.getOptions().subscribe((data: any) => {
      if (data['status'] == 'Success') {
        if (data['user_groups']["status"] == 'Success') {
          this.user_groups = data['user_groups']['data'];
        }
        if (data['user_access_types']["status"] == 'Success') {
          this.user_access_types = data['user_access_types']['data'];
        }
      }

    });
  }
}
